/* A native `title` is a hover affordance. On a touch screen the browser shows it
   on tap instead and leaves it sitting over whatever is underneath, so hand one
   out only to pointers that can actually hover.

   For decorative hints only ("Open Fundraising" on a card that already says so).
   An icon-only button keeps its plain `title` — there it is the accessible name,
   not a hint. */
export const hoverTitle = (text) =>
  (typeof window !== 'undefined' && window.matchMedia?.('(hover: hover)').matches ? text : undefined);

export default hoverTitle;
